module.exports = __webpack_public_path__ + "img/p3-plane.75a1fd48.png";